module.exports = __webpack_public_path__ + "img/rgznjs-1-sm.44cc5512.jpg";